import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_UPDATE,
  ACTIVATEEMAIL_AUTH_UPDATE,
  MAINPHOTO_UPDATE,
  AUTH_ROLEGET,
} from './authConstant';
import { createReducer } from '../../common/utilities/reducerUtils';

const initialState = {
  isAuth: false,
  token: null,
  sessionId: null,
  vusn: null,
  userId: null,
  authorities: {},
  name: null,
  username: null,
  mainPhoto: null,
  expiresIn: null,
  role: {},
  dataOptionRelation: null,
  emailRecovery: null,
};

const authLogin = (state, payload) => {
  return { ...state, ...payload.auth };
};

const authLogout = (state) => {
  return {
    isAuth: false,
    token: null,
    userId: null,
    authorities: {},
    name: null,
    username: null,
    mainPhoto: null,
    expiresIn: null,
  };
};

const authUpdate = (state, payload) => {
  return {
    ...state,
    ...payload.auth,
  };
};

const activateEmailAuthUpdate = (state, payload) => {
  return {
    ...state,
    username: payload.auth.username,
    vusn: payload.auth.username,
    emailRecovery: payload.auth.username,
  };
};

const mainPhotoUpdate = (state, payload) => {
  return {
    ...state,
    ...payload.mainPhoto,
  };
};

const authroleGet = (state, payload) => {
  let role = payload.role;
  let detail = role?.detail ?? [];
  let dataOptionRelation = detail.map((item) => {
    return { key: item, id: item, value: item, text: item };
  });
  return {
    ...state,
    dataOptionRelation,
  };
};

export default createReducer(initialState, {
  [AUTH_LOGIN]: authLogin,
  [AUTH_LOGOUT]: authLogout,
  [AUTH_UPDATE]: authUpdate,
  [ACTIVATEEMAIL_AUTH_UPDATE]: activateEmailAuthUpdate,
  [MAINPHOTO_UPDATE]: mainPhotoUpdate,
  [AUTH_ROLEGET]: authroleGet,
});
